import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useHistory } from 'react-router-dom';
import logo from '../assets/images/logo.svg';
import collaboratorTitle from '../assets/images/title.svg';
import logoutButton from '../assets/images/logoutButton.svg'; // Assuming you have a logout icon

const EspacoColaboradorDashboard = () => {
  const { currentUser, logout } = useAuth();
  const history = useHistory();

  useEffect(() => {
    // Configure Chatling
    window.chtlConfig = { chatbotId: '3878395237' };

    // Create and load the script
    const script = document.createElement('script');
    script.async = true;
    script.dataset.id = '3878395237';
    script.id = 'chatling-embed-script';
    script.type = 'text/javascript';
    script.src = 'https://chatling.ai/js/embed.js';

    document.body.appendChild(script);

    // Cleanup function to remove the script when component unmounts
    return () => {
      removeChatScript();
    };
  }, []);

  const removeChatScript = () => {
    const script = document.getElementById('chatling-embed-script');
    if (script) {
      document.body.removeChild(script);
    }

    // Also remove any chatbot UI elements that might have been created
    const chatElements = document.querySelectorAll('[id^="chatling"]');
    chatElements.forEach((element) => {
      element.remove();
    });
  };

  const handleLogout = () => {
    // Remove the chat script before logging out
    removeChatScript();

    logout();
    history.push('/espaco-colaborador');
  };

  return (
    <div className='espaco-colaborador'>
        <div className='header-content'>
          <div className='header-text'>
            <img src={collaboratorTitle} alt='Título da área de colaborador' />
            <p className='espaco-colaborador-welcome'>
              Bem-vindo(a), {currentUser?.username}! Aqui você encontra tudo o
              que precisa: comunicados, benefícios, eventos, oportunidades e
              muito mais para o seu dia a dia na Getinfo.
            </p>
            <button onClick={handleLogout} className='logout-button'>
              <img src={logoutButton} alt="logout icon" className="icon"/>
                Sair
            </button>
          </div>
          <div className='header-logo'>
            <img src={logo} alt='Getinfo Logo' />
          </div>
        </div>
    </div>
  );
};

export default EspacoColaboradorDashboard;
